// Filename - components/landing/InnovationFirst.js

import React  from "react";
import { Container, Row, Col} from "react-bootstrap";
import { Link } from "react-router-dom";


export default function Clients (){


    return (
      <Container fluid className="p-5" style={{backgroundColor: '#eef6fe'}}>
         <Row className="mx-3 mt-3 mb-3">
            <h3 className="display-4" style={{color:'#639fdd'}}>Our Clients and Partners </h3>
            <p className="lead">We work with after school programs, universities, learning centers, and more to offer our creativity focused programs, tailored to fit within existing instruction or new initiatives. </p>
         </Row>

         <Row className="mx-3 mt-3 mb-3" style={{opacity:'0.5'}}>
            <Col className="col-3 col-md-3">
               <img 
                  src="images/partners/EvolveMeLogo.png" 
                  width="80%"
                  alt="EvolveMe" 
                  fluid="true"
                   />
            </Col>

            <Col className="col-3 col-md-3">
               <img 
                  src="images/partners/NMoELogo.png" 
                  width="80%"
                  alt="National Museum Of Education" 
                  fluid="true"
                   />
            </Col>

            <Col className="col-2 col-md-3">
               <img 
                  src="images/partners/innovationworldLogo.png" 
                  width="80%"
                  alt="Innovation World" 
                  fluid="true"
                   />
            </Col>

            <Col className="col-3 col-md-3">
               <img 
                  src="images/partners/UWRobinsonCenterLogo.png" 
                  width="80%"
                  alt="UW Robinson Center" 
                  fluid="true"
                   />
            </Col>

            <Col className="col-2 col-md-3">
               <img 
                  src="images/partners/creativityAndEducationLogo.png" 
                  width="80%"
                  alt="Creativity and Education" 
                  fluid="true"
                   />
            </Col>

            <Col className="col-2 col-md-3">
               <img 
                  src="images/partners/youngEntrepreneurInstituteLogo.png" 
                  width="80%"
                  alt="Young Entrepreneur Institute" 
                  fluid="true" />
            </Col>

            <Col className="col-2 col-md-3">
               <img 
                  src="images/partners/everettSDLogo.png" 
                  width="80%"
                  alt="Everett School District" 
                  fluid="true" />
            </Col>

            <Col className="col-2 col-md-3">
               <img 
                  src="images/partners/positiveAllyLogo.png" 
                  width="80%"
                  alt="Positive Ally" 
                  fluid="true" />
            </Col>

            <Col className="col-2 col-md-3">
               <img 
                  src="images/partners/belougaLogo.png" 
                  width="80%"
                  alt="Belouga" 
                  fluid="true" />
            </Col>
            
         </Row>

      </Container>
    )

}
